import pulse from '@finn-no/pulse-sdk';
import { PersistedPPID } from '../../shared/types/ast';
import { displayAdsLog } from './debug';
import localStorage from './localStorage';

function handlePPIDResponse(data) {
    let value = undefined;
    if (data.status === 'fulfilled') value = data.value;
    return value;
}

export function getPPID(): PersistedPPID | null {
    displayAdsLog(`Get PPID: ${window?.FINN?.banner?.PPID}`);
    return localStorage.readValue('displayads-ppid');
}

export async function persistPPID(): Promise<PersistedPPID> {
    try {
        // const schibstedAccountNumber = window.finnUserId || undefined;
        let ppid1, ppid2;
        const tracker = await getTracker();
        const [ppid1Res, ppid2Res] = await Promise.allSettled([
            getLoggedInPPID(tracker),
            getNotLoggedInPPID(tracker),
        ]);

        try {
            ppid1 = handlePPIDResponse(ppid1Res);
        } catch (e) {
            console.error(e);
        }

        // Get logged out PPID no matter what for consistency on tracking
        try {
            ppid2 = handlePPIDResponse(ppid2Res);
        } catch (e) {
            console.error(e);
        }

        const data = {
            ppid1,
            ppid2,
        };

        // Set the object on window for use in banners.tsx and other potential places
        window.FINN.banner.PPID = data;
        localStorage.persistValue('displayads-ppid', data);
        return data;
    } catch (err) {
        const undefData = {
            ppid1: undefined,
            ppid2: undefined,
        };
        localStorage.persistValue('displayads-ppid', undefData);
        return undefData;
    }
}

export function getTracker() {
    return new Promise((resolve) => {
        pulse.getTracker(async (tracker) => {
            resolve(tracker);
        });
    });
}

export function getLoggedInPPID(tracker): Promise<string | undefined> {
    return new Promise((resolve, reject) => {
        tracker.getXandrPPID1().then(resolve).catch(reject);
    });
}

export function getNotLoggedInPPID(tracker): Promise<string | undefined> {
    return new Promise((resolve, reject) => {
        tracker.getXandrPPID2().then(resolve).catch(reject);
    });
}
